import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import DOMPurify from "dompurify";
import { loadPageContent } from '../../../../actions/content';

class TextViewer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.dispatch(loadPageContent(`api/pages/${this.props.pageSlug}`));
  }

  render() {
    const contentText = this.props.contents[`${this.props.pageSlug}_content_text`];

    if (contentText) {
      return (
        <Row>
          <Col lg={12}>
            <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(contentText.body)}}/>
          </Col>
        </Row>
      );
    }

    return null;
  }
};

const mapStateToProps = (state) => {
  return {
    contents: state.content.list,
  };
};

export default connect(mapStateToProps)(TextViewer);



// WEBPACK FOOTER //
// ./src/components/common/editor/text-viewer/index.jsx